import {Component, OnInit} from '@angular/core';
import {FollowUpService} from "./follow-up.service";
import {FollowUpModel} from "./follow-up.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup} from "@angular/forms";

declare let swal, $: any;

@Component({
  selector: 'app-follow-up',
  templateUrl: './follow-up.component.html'
})
export class FollowUpComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"descricao":"", "vencimento":"", "valor":"", "opcao": ""};

  followup: FollowUpModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listNotificacoes = [];

  listOpcoes = [
    {"texto": this.func.traduzir('front.unico'), "valor": "u"},
    {"texto": this.func.traduzir('front.mensal'), "valor": "m"},
    {"texto": this.func.traduzir('front.anual'), "valor": "a"}
  ];

  constructor(
    formBuilder: FormBuilder,
    private followupService: FollowUpService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'followup'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      descricao: [],
      vencimento: [],
      valor: [],
      opcao: []
    });
  }

  ngOnInit() {
    this.getPage(1);

    // busca lista de notificacoes
    this.followupService.getNotificacoes()
      .subscribe(res => {
        console.log('listNotificacoes', res);
        this.listNotificacoes = res.Payload;
      },
      error => {
        this.func.showErro(error.json());
      });
  }

  delete(follow) {
    let followup = this.followup;
    let followupService = this.followupService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarFollowUp')+follow.desccricao,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(followup);
        }

        let index = followup.indexOf(follow);
        followup.splice(index, 1);

        followupService.apagar(follow.id_followup)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.followup = followup;
            },
            err => {
              // Revert the view back to its original state
              followup.splice(index, 0, follow);
              self.followup = followup;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.descricao != ''){
      filtros['descricao'] = '**:'+this.filtroPesquisa.descricao;
    }

    if(this.filtroPesquisa.vencimento != ''){
      filtros['vencimento'] = this.filtroPesquisa.vencimento;
    }

    if(this.filtroPesquisa.valor != ''){
      filtros['valor'] = this.filtroPesquisa.valor;
    }

    if(this.filtroPesquisa.opcao != ''){
      filtros['opcao'] = this.filtroPesquisa.opcao;
    }

    this.followupService.getPaginacao(pagina,this.itensPorPagina, null, filtros)
      .subscribe(data => {
        this.followup = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  addNotificacao(){
    this.listNotificacoes.push({'email': ''});
  }

  removeNotificacao(i){
    this.listNotificacoes.splice(i, 1);
  }

  changeNotificacao(e, indice){
    console.log(indice, e.target.value);
    console.log(this.func.validaEmail(e.target.value));

    if(!this.func.validaEmail(e.target.value)){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.emailInvalido'), 'erro');
    }

    let qtdEmail = 0;
    for(let i in this.listNotificacoes){
      if(this.listNotificacoes[i].email == e.target.value){
        qtdEmail++;
      }
    }

    if(qtdEmail > 1){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.emailJaCadastradoNotificacao'), 'erro');
      this.listNotificacoes[indice].email = '';
    }

  }

  updNotificacoes(){

    // valida a lista de emails
    let qtdEmail = 0;
    let emailErro = false;
    for(let i in this.listNotificacoes){
      qtdEmail++;
      if(!this.func.validaEmail(this.listNotificacoes[i].email)){
        emailErro = true;
      }
    }

    // verifica se teve algum email cadastrado
    if(qtdEmail == 0){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.nenhumEmailCadastradoNotificacao'), 'erro');
      return false;
    }

    // verifica se teve algum email invalido
    if(emailErro){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.umOuMaisEmailsInvalidos'), 'erro');
      return false;
    }


    qtdEmail = 0;
    for(let x in this.listNotificacoes) {
      for (let i in this.listNotificacoes) {
        if ((this.listNotificacoes[i].email == this.listNotificacoes[x].email) && (i != x)) {
          qtdEmail++;
        }
      }
    }

    if(qtdEmail > 0){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.umOuMaisEmailsRepetidos'), 'erro');
    }

    // salva lista de emails
    this.followupService.updNotificacoes(this.listNotificacoes)
      .subscribe(res => {})
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"descricao":"", "vencimento":"", "valor":"", "opcao": ""};
  }
}



// WEBPACK FOOTER //
// ./src/app/follow-up/follow-up.component.ts